import { __awaiter } from "tslib";
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { lookupM365AppDefinition } from '../M365AppDefinitionService';
/**
 * Make call to Teams MT service
 */
export const fetchAppDefinitionsFromAppsService = (appId) => __awaiter(void 0, void 0, void 0, function* () {
    const context = yield fetchOfficeComponentContext();
    const appDefinitions = yield lookupM365AppDefinition({
        officeComponentContext: context,
        appId: appId,
    });
    return appDefinitions;
});
//# sourceMappingURL=fetchAppDefinitionsFromAppsService.js.map